import { Link, useParams, useSearchParams } from "react-router-dom";
import TransferDetailView from "@/features/transfers/transfer-detail";
import { resolveTransferDetailState } from "@/features/transfers/transfer-state";
import { DataSourceBadge } from "@/components/data-display/data-source-badge";
import { useTransferDetail } from "@/hooks/use-transfer-detail";

export default function TransferDetailPage() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const state = searchParams.get("state") ?? undefined;
  const { detail, loading, error, source, refresh } = useTransferDetail(id!);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-16">
        <div className="spinner" aria-label="Loading transfer" />
      </div>
    );
  }

  if (error || !detail) {
    return (
      <div className="max-w-[760px]">
        <h1 className="text-xl font-bold text-ink">Transfer not found</h1>
        <p className="mt-2 text-sm text-muted">
          {error || `No transfer intent matches "${id}".`}
        </p>
        <Link to="/transfers" className="mt-4 inline-block text-[13px] font-semibold text-primary hover:underline">
          ← Back to Transfers
        </Link>
      </div>
    );
  }

  const resolved = resolveTransferDetailState(state, detail.defaultState);
  return (
    <div>
      <div className="mb-3 flex items-center gap-2">
        <DataSourceBadge source={source} />
        <button
          type="button"
          onClick={refresh}
          className="text-xs text-muted underline hover:text-ink"
        >
          Refresh
        </button>
      </div>
      <TransferDetailView detail={detail} state={resolved} />
    </div>
  );
}
